/**
 * SuggestController – barrierefreie Version
 * ==========================================
 * ARIA 1.2 Combobox-Pattern, WCAG 2.1 AA
 *
 * Änderungen gegenüber Original:
 *  - Input erhält role="combobox" + alle erforderlichen aria-* Attribute
 *  - Live-Region (aria-live="polite") für Screen-Reader-Ansagen
 *  - devbridgeAutocomplete-Container: role="listbox", aria-label
 *  - Jede .autocomplete-suggestion: role="option", eindeutige id, aria-selected
 *  - .autocomplete-group: role="group" + aria-label statt role="presentation"
 *  - previewImage <img> erhält alt-Text aus suggestion.data.title
 *  - Alle Dekorations-Icons behalten aria-hidden="true"
 *  - Tastatursteuerung (↑↓ Enter Escape) bleibt vollständig erhalten
 *    (devbridgeAutocomplete liefert diese nativ; wir ergänzen nur aria-activedescendant)
 *  - onSelect, transformResult, AJAX-serviceUrl vollständig unverändert
 *
 *  ToDo:
 *  Problem, ESC-Taste muss 2x gedrückt werden, um das Dropdown-Menü zu schließen (ist scheinbar ein Bug in NVDA: https://github.com/nvaccess/nvda/issues/15170)
 *  strong-Tag zu mark-Tag
 */

function SuggestController() {
    this.init = function () {
        jQuery('form[data-suggest]').each(function () {
            var $form = $(this),
                $searchBox = $form.find('.tx-solr-suggest'),
                $formAutoComplete;

            if ($form.find('.tx-solr-autocomplete').length > 0) {
                $formAutoComplete = $form.find('.tx-solr-autocomplete');
            } else {
                $formAutoComplete = $('body');
            }
            if ($searchBox.length === 0) {
                $searchBox = $form;
            }
            $searchBox.css('position', 'relative');

            // ── i18n: Übersetzungen aus Data-Attributen lesen ───────────────────
            var i18n = {
                listboxLabel: $form.data('i18n-listbox-label') || 'Suchvorschläge',
                announcementSingular: $form.data('i18n-announcement-singular') || 'Vorschlag verfügbar. Mit Pfeiltasten navigieren.',
                announcementPlural: $form.data('i18n-announcement-plural') || 'Vorschläge verfügbar. Mit Pfeiltasten navigieren.',
                typePage: $form.data('i18n-type-page') || 'Seite',
                typeArticle: $form.data('i18n-type-article') || 'Artikel',
                typeDocument: $form.data('i18n-type-document') || 'Dokument',
                typeContact: $form.data('i18n-type-contact') || 'Kontakt',
                typeGlossary: $form.data('i18n-type-glossary') || 'Glossar-Eintrag',
                typeProject: $form.data('i18n-type-project') || 'Projekt',
                typeNews: $form.data('i18n-type-news') || 'Nachricht',
                typeDownload: $form.data('i18n-type-download') || 'Download'
            };

            // ── Live-Region erzeugen (einmalig pro Form) ───────────────────
            var liveRegionId = 'solr-suggest-status-' + $form.attr('id');
            if ($('#' + liveRegionId).length === 0) {
                $('<div>', {
                    id:             liveRegionId,
                    role:           'status',
                    'aria-live':    'polite',
                    'aria-atomic':  'true'
                }).css({
                    position: 'absolute',
                    width:    '1px',
                    height:   '1px',
                    overflow: 'hidden',
                    clip:     'rect(0,0,0,0)',
                    'white-space': 'nowrap'
                }).appendTo('body');
            }

            function announce(msg) {
                var $lr = $('#' + liveRegionId);
                $lr.text('');
                setTimeout(function () { $lr.text(msg); }, 50);
            }

            // ── Input: ARIA-Combobox-Attribute setzen ──────────────────────
            var $input = $form.find('.tx-solr-suggest');
            var listboxId = 'solr-listbox-' + ($input.attr('id') || Math.random().toString(36).slice(2));

            $input
                .attr('role',               'combobox')
                .attr('aria-autocomplete',  'list')
                .attr('aria-expanded',      'false')
                .attr('aria-controls',      listboxId)
                .attr('aria-activedescendant', '')
                .attr('autocomplete',       'off')
                .attr('autocorrect',        'off')
                .attr('autocapitalize',     'off')
                .attr('spellcheck',         'false');

            // ── Form-Submit-Guard (unverändert) ────────────────────────────
            $form.on('submit', function (e) {
                if ($form.find('.tx-solr-suggest-focus').val() === '') {
                    e.preventDefault();
                    $form.find('.tx-solr-suggest-focus').focus();
                }
            });

            // ── devbridgeAutocomplete ──────────────────────────────────────
            $form.find('.tx-solr-suggest').devbridgeAutocomplete({

                // ── AJAX-Konfiguration (vollständig unverändert) ───────────
                serviceUrl:              $form.data('suggest'),
                dataType:                'json',
                paramName:               'tx_solr[queryString]',
                groupBy:                 'category',
                maxHeight:               1000,
                appendTo:                $formAutoComplete,
                autoSelectFirst:         false,
                triggerSelectOnValidInput: false,
                width:                   $searchBox.outerWidth() * 0.66,

                // ── onSelect (vollständig unverändert) ─────────────────────
                onSelect: function (suggestion) {
                    if (suggestion.data.link) {
                        if (suggestion.data.link.indexOf('https://www.youtube.com') === 0) {
                            openVideoOverlay(suggestion.data.link);
                        } else {
                            location.href = suggestion.data.link;
                        }
                    } else {
                        $form.trigger('submit');
                    }
                },

                // ── transformResult (vollständig unverändert) ──────────────
                transformResult: function (response) {
                    if (!response.suggestions) return { suggestions: [] };
                    var firstSuggestion,
                        result = {
                            suggestions: $.map(response.suggestions, function (count, suggestion) {
                                if (!firstSuggestion) firstSuggestion = suggestion;
                                return {
                                    value: suggestion,
                                    data: {
                                        category: 'suggestion',
                                        count:    count
                                    }
                                };
                            })
                        };
                    $.each(response.documents, function (key, value) {
                        var dataObject   = value;
                        var defaultGroup = $form.data('suggest-header') ? $form.data('suggest-header') : 'Top results';
                        dataObject.category = defaultGroup;
                        if (dataObject.group) {
                            dataObject.category = $form.data('suggest-header-' + dataObject.group)
                                ? $form.data('suggest-header-' + dataObject.group)
                                : dataObject.group;
                        }
                        result.suggestions.push({ value: firstSuggestion, data: dataObject });
                    });
                    return result;
                },

                // ── beforeRender – ARIA-Anreicherung ──────────────────────
                beforeRender: function (container, suggestions) {
                    // Gruppe "suggestion" (erste Autocomplete-Group) entfernen
                    container.find('.autocomplete-group:first').remove();

                    // Container = Listbox
                    container
                        .attr('id',         listboxId)
                        .attr('role',       'listbox')
                        .attr('aria-label', i18n.listboxLabel)
                        .addClass('tx-solr-autosuggest bg-white border-t border-b border-l border-r')
                        .addClass('border-bleAkzentfarbe-darkgreen -mt-px flex flex-col items-start p-2.5');

                    // Jedes Option-Element: role + eindeutige id + aria-selected
                    container.find('.autocomplete-suggestion').each(function (idx) {
                        $(this)
                            .attr('role',          'option')
                            .attr('id',            listboxId + '-opt-' + idx)
                            .attr('aria-selected', 'false');
                    });

                    // Gruppenüberschriften: role="group" + aria-label
                    container.find('.autocomplete-group').each(function () {
                        var groupLabel = $(this).text().trim();
                        $(this)
                            .attr('role',       'group')
                            .attr('aria-label', groupLabel)
                            .addClass('py-bundPadding-5px w-full')
                            .html(
                                '<p class="before:border-b before:border-bundFarben-hellgrau1 before:inset-x-0 ' +
                                'before:absolute before:top-1/2 before:content-[\'\'] text-center relative">' +
                                '<span class="!inline-block bg-white relative px-bundPadding-5px">' +
                                '<i class="far fa-thumbs-up" aria-hidden="true"></i> ' +
                                '<span class="uppercase">' + groupLabel + '</span>' +
                                '</span></p>'
                            );
                    });

                    // Input: aria-expanded + Anzahl ankündigen
                    $input.attr('aria-expanded', 'true');
                    var count = container.find('[role="option"]').length;
                    announce(count + ' ' + (count === 1 ? i18n.announcementSingular : i18n.announcementPlural));

                    $searchBox.parent().addClass('autocomplete-active').fadeIn();
                },

                // ── formatResult (vollständig unverändert, nur img alt ergänzt) ──
                formatResult: function (suggestion, currentValue) {
                    if (!currentValue) {
                        return suggestion.value;
                    }
                    var pattern = '(' + $.Autocomplete.utils.escapeRegExChars(currentValue.trim()) + ')';

                    if (suggestion.data.category === 'suggestion') {
                        return suggestion.value
                            .replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>')
                            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
                            .replace(/&lt;(\/?strong)&gt;/g, '<$1>');
                    } else {
                        var title = suggestion.data.title
                            .replace(new RegExp(pattern, 'gi'), '<em>$1<\/em>')
                            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
                            .replace(/&lt;(\/?em)&gt;/g, '<$1>');

                        var type = suggestion.data.type;
                        var tel  = suggestion.data.orgaTelefon_stringS;
                        if (tel) {
                            tel = ', <span class="bund-text-color-hellgrau1">' + tel + '</span>';
                        }

                        if (type === 'pages') {
                            title = '<i class="fas fa-file-alt fa-fw pr-2" aria-hidden="true"></i><span class="sr-only">' + i18n.typePage + ': </span>' + title;
                        }
                        if (type === 'tx_news_domain_model_news') {
                            title = '<i class="fas fa-newspaper fa-fw pr-2" aria-hidden="true"></i><span class="sr-only">' + i18n.typeNews + ': </span>' + title;
                        }
                        if (type === 'sys_file_metadata') {
                            var filename = suggestion.data.link.split('/').pop();
                            title = '<i class="fas fa-download fa-fw pr-2" aria-hidden="true"></i><span class="sr-only">' + i18n.typeDownload + ': </span>' + filename;
                        }
                        if (type === 'tx_glossaryone_domain_model_term') {
                            title = '<i class="fas fa-book fa-fw pr-2" aria-hidden="true"></i><span class="sr-only">' + i18n.typeGlossary + ': </span>&nbsp;' + title;
                        }
                        if (type === 'tx_bletelefonbuch_domain_model_telefonbuch') {
                            title = '<i class="fas fa-phone fa-fw pr-2" aria-hidden="true"></i><span class="sr-only">' + i18n.typeContact + ': </span>' + title;
                        }
                        if (type === 'tx_bleinformprojekte_domain_model_projekte') {
                            title = '<i class="far fa-list-alt fa-fw pr-2" aria-hidden="true"></i><span class="sr-only">' + i18n.typeProject + ': </span>' + title;
                        }

                        // previewImage: alt-Text aus title (Vorschaubild für Screen-Reader beschreibbar)
                        var imgHtml = '';
                        if (!!suggestion.data.previewImage) {
                            var altText = suggestion.data.title
                                ? suggestion.data.title.replace(/"/g, '&quot;')
                                : '';
                            imgHtml = '<figure' + (!!suggestion.data.hasVideo ? ' class="hasVideo"' : '') + '>' +
                                '<img src="' + suggestion.data.previewImage + '" alt="' + altText + '" /></figure>';
                        }

                        return '<div class="' + suggestion.data.type + '">' +
                            imgHtml +
                            '<a href="' + suggestion.data.link + '" class="internal-link">' + title + '</a>' +
                            '</div>';
                    }
                }

            })
                // ── Tastatur: aria-activedescendant nachführen ─────────────────
                // HINWEIS: devbridgeAutocomplete ruft stopImmediatePropagation()
                // im keydown-Handler auf → unser Handler muss auf 'keyup' lauschen.
                .on('keyup', function (e) {
                    // Nur bei Pfeiltasten, Enter, Escape reagieren
                    var key = e.which || e.keyCode;
                    if (key !== 38 && key !== 40 && key !== 13 && key !== 27) {
                        return;
                    }

                    var $container = $('#' + listboxId);
                    if (!$container.length) {
                        $input.attr('aria-activedescendant', '');
                        return;
                    }

                    var $active = $container.find('.autocomplete-suggestion.autocomplete-selected');

                    if ($active.length) {
                        // Falls noch keine ID vergeben (z.B. nach Re-Render)
                        if (!$active.attr('id')) {
                            $container.find('.autocomplete-suggestion').each(function (idx) {
                                $(this).attr('id', listboxId + '-opt-' + idx);
                            });
                        }
                        var activeId = $active.attr('id') || '';
                        $input.attr('aria-activedescendant', activeId);
                        // Alle Options zurücksetzen, dann aktive setzen
                        $container.find('[role="option"]').attr('aria-selected', 'false');
                        $active.attr('aria-selected', 'true');
                    } else {
                        $input.attr('aria-activedescendant', '');
                        $container.find('[role="option"]').attr('aria-selected', 'false');
                    }
                })
                .on('blur', function () {
                    $searchBox.parent().removeClass('autocomplete-active');
                    $input
                        .attr('aria-expanded',       'false')
                        .attr('aria-activedescendant', '');
                    var $box = $(this);
                    setTimeout(function () {
                        $box.devbridgeAutocomplete('hide');
                    }, 200);
                });
        });
    };
}

jQuery(document).ready(function () {
    var solrSuggestController = new SuggestController();
    solrSuggestController.init();

    jQuery('body').on('tx_solr_updated', function () {
        solrSuggestController.init();
    });

    var SolrTopSearch  = $('#topsearch-field');
    var SolrMainSearch = $('#search-field');

    // Listbox-Container: role wird jetzt in beforeRender gesetzt,
    // hier als Fallback für bereits gerenderte Container
    $('div.autocomplete-suggestions').attr('role', 'listbox');

    SolrTopSearch.focus(function () {
        $('div.autocomplete-suggestions').outerWidth($('input#topsearch-field').outerWidth() + 'px');
    });
    SolrMainSearch.focus(function () {
        $('div.autocomplete-suggestions').outerWidth($('input#search-field').outerWidth() + 'px');
    });
});
//# sourceMappingURL=suggest_controller.js.map
